import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as BSL_Common from "../../../components/BSL_CommonControls";
import BSL_TextInput from "../../../components/BSL_TextInput";
import * as APP from "../../../redux_store/appState";
import { updateAreaSpecificationShape } from "../../../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../../../redux_store/jobState_Schemas";

const useStyles = makeStyles({
    root: {
        padding: "0px 8px 8px 8px",
    },
    cutoutSummary: {
        color: "#3a3a3a",
    },
    paper_root: {
        background: "#090909ad",
    },
});

export default function ShapeDesignTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { areaIndex } = props;
    const job = useSelector((state) => state.job);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const ShapeParameters = area_design_specs?.SHAPE;

    let maxSheetOverhang = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang;
    if (!maxSheetOverhang) maxSheetOverhang = 200;

    const config = useSelector((state) => state.config);
    const design_option = config?.design_options?.[area_design_specs.SHAPE.DesignType];

    const updateShapeDataValue = (dataField, value = null) => {
        let error = dispatch(updateAreaSpecificationShape(areaIndex, null, dataField, value));
        if (error && error.error) {
            dispatch(APP.showDialogData(error));
        }
    };
    const updateShapeData =
        (dataField) =>
        (event, value = null) => {
            if (value === null) value = event?.target?.value ? event?.target?.value : event;

            return updateShapeDataValue(dataField, value);
        };

    let maxPostHeight = 3200;

    return (
        <div className={classes.root} key={areaIndex}>
            <BSL_Common.SectionHeader>Dimensions</BSL_Common.SectionHeader>
            <BSL_Common.SectionContainer
                style={{
                    marginBottom: "-28px",
                }}
            >
                <BSL_Common.SectionRow>
                    <BSL_TextInput
                        label="Length"
                        value={ShapeParameters?.Length}
                        tight
                        min={design_option?.length_range?.min ? design_option?.length_range?.min : 300}
                        max={design_option?.length_range?.max ? design_option?.length_range?.max : 20000}
                        endAdornment="mm"
                        onBlur={updateShapeData("Length")}
                    />
                    <BSL_TextInput
                        label="Depth"
                        value={ShapeParameters?.Depth}
                        tight
                        min={design_option?.depth_range?.min ? design_option?.depth_range?.min : 500}
                        max={design_option?.depth_range?.max ? design_option?.depth_range?.max : 20000}
                        endAdornment="mm"
                        onBlur={updateShapeData("Depth")}
                    />
                    <BSL_TextInput
                        label="Height"
                        value={ShapeParameters?.Height}
                        tight
                        min={design_option?.height_range?.min ? design_option?.height_range?.min : 100}
                        max={
                            maxPostHeight
                                ? maxPostHeight
                                : design_option?.height_range?.max
                                ? design_option?.height_range?.max
                                : 4000
                        }
                        endAdornment="mm"
                        onBlur={updateShapeData("Height")}
                        helperText={
                            <>
                                FFL to <span style={{ fontWeight: 600 }}>Sheet</span> Underside
                            </>
                        }
                    />
                </BSL_Common.SectionRow>
            </BSL_Common.SectionContainer>
        </div>
    );
}
